(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  /**
   * Estado "ya registrado" del formulario de Próximamente.
   *
   * design/screens/proximamente.html pide tres estados: error, ya
   * registrado y éxito. Shopify solo da dos: responde éxito aunque el email
   * ya exista, y lo hace a propósito, para que nadie pueda averiguar quién
   * está en la lista probando correos.
   *
   * Así que el tercero se resuelve donde sí se sabe: este navegador. Se
   * recuerdan los correos enviados desde aquí y, si alguien repite el mismo,
   * el mensaje lo dice. No afirma nada del servidor, solo lo que pasó en
   * este teléfono, que es justo el caso real: la persona duda de si le dio
   * a enviar y lo intenta otra vez.
   *
   * Si el navegador no deja guardar nada, en modo privado por ejemplo, todo
   * sigue funcionando: simplemente se ve el mensaje de éxito de siempre.
   */
  (() => {
    const CLAVE = 'pocketly:emails';
    const PENDIENTE = 'pocketly:repetido';

    const leer = (clave) => {
      try {
        return window.localStorage.getItem(clave);
      } catch {
        return null;
      }
    };

    const escribir = (clave, valor) => {
      try {
        window.localStorage.setItem(clave, valor);
      } catch {
        /* modo privado: se sigue sin recordar nada */
      }
    };

    const normalizar = (email) => email.trim().toLowerCase();

    const enviados = () => {
      const crudo = leer(CLAVE);
      if (!crudo) return [];
      try {
        const lista = JSON.parse(crudo);
        return Array.isArray(lista) ? lista : [];
      } catch {
        return [];
      }
    };

    // 1. Al volver de enviar, Shopify pinta el mensaje de éxito. Si el correo
    //    ya se había mandado desde aquí, se cambia el texto.
    const exito = document.querySelector('.email-signup__message-text');
    if (exito && leer(PENDIENTE) === 'si') {
      exito.textContent = exito.dataset.repetido || 'Ese email ya está en la lista. Te avisamos igual.';
      escribir(PENDIENTE, 'no');
    }

    // 2. Al enviar, se apunta el correo y se marca si ya estaba.
    const form = document.querySelector('.section-password .email-signup__form, .section-password form');
    const campo = form && form.querySelector('input[type="email"]');
    if (!form || !campo) return;

    form.addEventListener('submit', () => {
      const email = normalizar(campo.value);
      if (!email) return;
      const lista = enviados();
      escribir(PENDIENTE, lista.includes(email) ? 'si' : 'no');
      if (!lista.includes(email)) {
        lista.push(email);
        // Se guardan como mucho diez: es una comodidad, no un registro.
        escribir(CLAVE, JSON.stringify(lista.slice(-10)));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pocketly-faq"] && !Shopify.designMode) return;
  try {
    
  /**
   * Filtro en vivo de preguntas frecuentes.
   *
   * Cada pregunta trae en data-busqueda su texto completo, pregunta y
   * respuesta juntas, para que buscar "cambio" encuentre también las que
   * solo lo mencionan en la respuesta.
   *
   * La comparación quita tildes: en un teclado móvil es normal escribir
   * "envio" sin acento, y no encontrar nada por eso es un fallo.
   */
  class PkFaq extends HTMLElement {
    connectedCallback() {
      this.buscador = this.querySelector('[data-pk-buscador]');
      this.input = this.querySelector('[data-pk-input]');
      this.vacio = this.querySelector('[data-pk-vacio]');
      this.items = [...this.querySelectorAll('[data-pk-faq-item]')];

      if (!this.input || this.items.length === 0) return;

      // Con pocas preguntas el buscador estorba más de lo que ayuda.
      const minimo = Number(this.dataset.minimo || 5);
      if (this.items.length < minimo) return;

      this.indice = this.items.map((el) => ({
        el,
        texto: this.#normalizar(el.dataset.busqueda || el.textContent || ''),
      }));

      this.input.addEventListener('input', () => this.#filtrar());
      this.buscador.hidden = false;
    }

    #normalizar(texto) {
      return texto
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();
    }

    #filtrar() {
      const consulta = this.#normalizar(this.input.value.trim());
      let visibles = 0;

      for (const { el, texto } of this.indice) {
        const coincide = consulta === '' || texto.includes(consulta);
        el.hidden = !coincide;
        if (coincide) visibles += 1;
        // Al filtrar se cierran las que quedan fuera, para que al borrar la
        // búsqueda la lista no aparezca medio desplegada.
        if (!coincide) el.open = false;
      }

      // Con una sola coincidencia, abrirla ahorra un clic.
      if (consulta !== '' && visibles === 1) {
        const unica = this.indice.find(({ el }) => !el.hidden);
        if (unica) unica.el.open = true;
      }

      if (this.vacio) {
        this.vacio.hidden = visibles !== 0;
        if (visibles === 0) this.vacio.textContent = this.dataset.sinResultados || '';
      }
    }
  }

  if (!customElements.get('pk-faq')) {
    customElements.define('pk-faq', PkFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pocketly-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  // Pop-up de newsletter. Se abre una vez tras el retraso configurado y
  // recuerda el cierre en localStorage durante N días. En el editor de
  // temas se abre siempre, para que la dueña pueda verlo mientras edita.
  (() => {
    const popup = document.getElementById('pk-newsletter-popup');
    if (!popup || typeof popup.showModal !== 'function') return;

    const CLAVE = 'pocketly:newsletter-popup';
    const dias = parseInt(popup.dataset.days || '30', 10);
    const retraso = parseInt(popup.dataset.delay || '5', 10) * 1000;
    const enEditor = Boolean(window.Shopify && window.Shopify.designMode);

    const visto = () => {
      if (enEditor) return false;
      try {
        const hasta = Number(window.localStorage.getItem(CLAVE) || 0);
        return Date.now() < hasta;
      } catch {
        // Modo privado o cookies bloqueadas: mejor no insistir.
        return true;
      }
    };

    const recordar = () => {
      try {
        window.localStorage.setItem(CLAVE, String(Date.now() + dias * 864e5));
      } catch {
        /* sin almacenamiento, no pasa nada */
      }
    };

    const cerrar = () => {
      recordar();
      if (popup.open) popup.close();
    };

    popup.querySelector('[data-pk-close]')?.addEventListener('click', cerrar);
    popup.addEventListener('close', recordar);

    // Si el formulario se envió bien, Shopify recarga con ?form_type=customer
    const exito = popup.querySelector('.pk-popup__ok');
    if (exito) {
      popup.showModal();
      recordar();
      return;
    }

    if (visto()) return;
    window.setTimeout(() => {
      if (!popup.open) popup.showModal();
    }, retraso);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pocketly-shipping"] && !Shopify.designMode) return;
  try {
    
  /**
   * Calculador de envío.
   *
   * No lleva datos propios: al arrancar recorre los bloques de zona que
   * haya en la página y arma la lista de provincias con lo que encuentra.
   * Así la dueña añade una zona en el editor y el desplegable se actualiza
   * solo, sin tocar este archivo.
   *
   * Se muestra solo si consigue al menos una provincia. Si los bloques no
   * tienen provincias escritas, el desplegable quedaría vacío y estorbaría
   * más que ayudar, así que se queda oculto y la tabla hace el trabajo.
   */
  class PkShippingCalculator extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-pk-select]');
      this.salida = this.querySelector('[data-pk-salida]');
      if (!this.select || !this.salida) return;

      this.zonas = this.#leerZonas();
      const provincias = this.#provinciasOrdenadas();
      if (provincias.length === 0) return;

      for (const nombre of provincias) {
        const op = document.createElement('option');
        op.value = nombre;
        op.textContent = nombre;
        this.select.append(op);
      }

      this.select.addEventListener('change', () => this.#mostrar());
      this.hidden = false;
    }

    /** Lee los bloques de zona del DOM. Devuelve [] si no hay ninguno. */
    #leerZonas() {
      const raiz = this.closest('.pk-envios') || document;
      return [...raiz.querySelectorAll('[data-pk-zona]')].map((el) => ({
        nombre: el.dataset.nombre || '',
        provincias: (el.dataset.provincias || '')
          .split(',')
          .map((p) => p.trim())
          .filter(Boolean),
        precio: el.dataset.precio || '',
        plazo: el.dataset.plazo || '',
        nota: el.dataset.nota || '',
      }));
    }

    /** Provincias únicas de todas las zonas, en orden alfabético local. */
    #provinciasOrdenadas() {
      const vistas = new Map();
      for (const zona of this.zonas) {
        for (const p of zona.provincias) {
          // Se guarda la primera grafía que aparece, pero se compara sin
          // tildes ni mayúsculas para no duplicar "Peravia" y "peravia".
          const clave = this.#normalizar(p);
          if (!vistas.has(clave)) vistas.set(clave, p);
        }
      }
      return [...vistas.values()].sort((a, b) => a.localeCompare(b, 'es'));
    }

    #normalizar(texto) {
      return texto
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim();
    }

    #zonaDe(provincia) {
      const clave = this.#normalizar(provincia);
      return this.zonas.find((z) => z.provincias.some((p) => this.#normalizar(p) === clave));
    }

    #mostrar() {
      const provincia = this.select.value;
      if (!provincia) {
        this.salida.textContent = '';
        return;
      }

      const zona = this.#zonaDe(provincia);
      if (!zona) {
        this.salida.textContent = this.dataset.sinZona || '';
        return;
      }

      const partes = [];
      partes.push(`Zona <strong>${this.#escapar(zona.nombre)}</strong>.`);

      if (zona.precio) {
        partes.push(`Envío <strong>${this.#escapar(zona.precio)}</strong>.`);
      } else {
        partes.push('<span class="pk-calc__pendiente">Tarifa por confirmar.</span>');
      }

      if (zona.plazo) {
        partes.push(`Entrega en ${this.#escapar(zona.plazo)}.`);
      }

      if (zona.nota) {
        partes.push(this.#escapar(zona.nota));
      }

      this.salida.innerHTML = partes.join(' ');
    }

    /** Los datos vienen de ajustes del tema, pero se escapan igual. */
    #escapar(texto) {
      const d = document.createElement('div');
      d.textContent = texto;
      return d.innerHTML;
    }
  }

  if (!customElements.get('pk-shipping-calculator')) {
    customElements.define('pk-shipping-calculator', PkShippingCalculator);
  }

  } catch(e) { console.error(e); }
})();
})();
